import script from "./pluginMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./pluginMenu.vue?vue&type=script&setup=true&lang=js"

import "./pluginMenu.vue?vue&type=style&index=0&id=606e27c8&lang=scss"

const __exports__ = script;

export default __exports__